//#region Angular Imports

import { IPromise, IQService, ITimeoutService } from 'angular'

//#endregion

//#region Util Imports

import * as $ from 'jquery'
import * as _ from 'underscore'
import { i18n } from './i18n/common.i18n'

//#endregion

//#region DevExtreme Imports

import CustomStore from 'devextreme/data/custom_store'
import { LoadOptions } from 'devextreme/data/load_options'
import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'
import 'devextreme/ui/form'
import 'devextreme/ui/color_box'
import 'devextreme/ui/number_box'
import 'devextreme/ui/select_box'
import 'devextreme/ui/text_area'
import 'devextreme/ui/text_box'
import 'devextreme/ui/validator'

//#endregion

//#region Service Imports

import { ReferenceTypeService } from '../../services/reference-type'

//#endregion

import { Api, LocalDictionaryFactory } from '../api/api.module'
import { ColumnModel } from '../api/api.models'

import { CommonHelper } from '../../helpers/common-helper'
import { ConvertHelper } from '../../helpers/convert-helper'
import { Dictionary, KeyType } from '../../helpers/dictionary'
import { UserSessionService } from '../../services/user-session'
import { LocalizationHelper } from '../../helpers/localization-helper'
import { PopupType } from '../../helpers/popup-manager'
import { ToastHelper, TypeHelper } from '../../helpers'
import { DataProviderListResult } from '../../data-provider'

import { Enums } from '../../models/common/enums'
import { IReferenceType } from '../../models/util/interfaces'
import { OpDataType } from '../../models/core/op-data-type'
import { OpDataTypeFormat } from '../../models/core/op-data-type-format'
import { OpDataTypeInGroup } from '../../models/core/op-data-type-in-group'
import { OpIssueStatus } from '../../models/core/op-issue-status'
import { OpTaskStatus } from '../../models/core/op-task-status'
import { OpPackageStatus } from '../../models/core/op-package-status'
import { OpLocationType } from '../../models/core'

import { ChangeStatusSelectItem } from './change-status/change-status.directive.controller'
import { TreeListOptions } from './tree-list/tree-list.controller'
import { IMRBaseControlDirectiveController } from './base'


interface ExtendedFormItem extends DevExpress.ui.dxFormSimpleItem {
    label?: { text: string }
    template?: string
    validationRules?: any[]
    isSelectPopover?: boolean
}

export interface CreateEditFieldSettings {
    id: number // idDataType
    caption: string
    format: OpDataTypeFormat // zamienić na dataTypeFormat
    isEditable: boolean
    referenceTypeId: number // zamienić na idReferenceType
    unitName: string // usunąć!!!
    type: number // zamienić na idDataTypeClass
}

export interface CreateEditField {
    id: number //idData
    idDataType: number
    index: number //indexNBR
    name: string
    value: any
    typeId: number // idDataTypeClass usunąc
    rowColor: any // zamienić na statusColor i ustalic type (chyba number)
}

export interface CreateEditSection {
    name: string
    type: string
    columns?: CreateEditFieldSettings[]//DO USUNIECIA!!! // zamienić na fields
    required?: CreateEditFieldSettings[]//DO USUNIECIA!!! // zamienić na requiredFields

    dataTypesToEdit?: OpDataTypeInGroup[]//TO DO!!! usunąć opcjonalnośc kiedy pozbędziemy się columns?
    dataTypesRequired?: OpDataTypeInGroup[] //TO DO!!! usunąć opcjonalnośc kiedy pozbędziemy się required?

    // dynamic fields / methods
    showRequiredError?: boolean

    // forms
    form?: DevExpress.ui.dxForm
    formData?: { [idDataType: number]: any }
    items?: ExtendedFormItem[]
    options?: DevExpress.ui.dxFormOptions

    //TO DO!!! ujednolicić zdarzenia zmiany wartości dla różnego rodzaju kontrolek
    onFieldChanged?: (e) => void
    onDateFieldChanged?: (e) => void
    onFieldValueChanged?: (e) => void
    onSelectNoteValueChanged?: (value: ChangeStatusSelectItem, dataType: Enums.DataType) => void
    onNoteValueChanged?: (value: string, dataType: Enums.DataType) => void
    initializedHandler?: (e) => void

    // grid
    grid?: DevExpress.ui.dxDataGrid
    gridOptions?: TreeListOptions
    showDatatypeLegend?: boolean
    selectedRows?: any[]
    selectedAdditionalDetailField?: any
    adding?: boolean
    addButton?: DevExpress.ui.dxButton
    addButtonOptions?: DevExpress.ui.dxButtonOptions
    removeButton?: DevExpress.ui.dxButton
    removeButtonOptions?: DevExpress.ui.dxButtonOptions
    additionalDetailFieldsSelectBoxOptions?: DevExpress.ui.dxSelectBoxOptions

    customSectionName?: string
}

export enum BulkEditComparationMode {
    Empty = 0,
    Single = 1,
    Multiple = 2
}

export type BulkEditComparation = { comparation: BulkEditComparationMode, selectedValue: string, selectedId: number }

export class CommonCreateEdit extends IMRBaseControlDirectiveController {

    // Consts

    private static get LOG_STRING(): string { return '[SIMAX.Common.CreateEdit] - %s' }

    /**
     * Data Types that display a dropdownbox with a select and a textarea for a note.
     */
    protected CHANGE_STATUS_ID_DATA_TYPES: [Enums.DataType, Enums.DataType][] = [
        [Enums.DataType.HELPER_ID_LOCATION_STATE_TYPE, Enums.DataType.LOCATION_STATE_TYPE_NOTE]
    ]

    // Consts End

    public static ReferenceObjectBaseParams = "form"
    public static ReferenceObjectExtendedParams = "grid"
    public static ReferenceObjectBulkParams = "formGrid"
    public static ReferenceObjectCustomParams = "custom"
    public static AddOrderSection = "addOrderSection"

    referenceTableCount: number = 0
    statesFormInstance: ng.IDeferred<DevExpress.ui.dxSelectBox>
    referenceDict: {
        idDataType: any,
        referenceType: any,
        referenceTableUniqueId: string
    }[] = []
    editedItems: any = {}

    constructor(
        protected readonly $scope: any,
        protected readonly api: Api,
        protected readonly localDictionary: LocalDictionaryFactory,
        protected readonly $q: IQService,
        protected readonly $timeout: ITimeoutService,
        protected readonly userSession: UserSessionService,
        protected readonly referenceTypeService: ReferenceTypeService = null
    ) {
        super()

        this.statesFormInstance = $q.defer<DevExpress.ui.dxSelectBox>()
    }

    protected loadForm(section: CreateEditSection, data: { [key: number]: CreateEditField }, formType, idReferenceType, widerWindow: boolean = false) {
        this.$scope.isLoading = true
        section.form.beginUpdate()
        section.items = []
        section.formData = {}
        var locationSelectedButtonAdded = false
        var items = section.items
        let promises: ng.IPromise<any>[] = []

        const maxCharCount = widerWindow ? 60 : 24

        this.getHasViewDictionary(section.columns)
            .then((hasViewDictionary: Dictionary<boolean>) => {
                for (var i = 0; i < section.columns.length; ++i) {
                    var fieldIsAdded = false
                    var column = section.columns[i]
                    if (this.isIdColumn(column, formType)) {
                        if (!data[column.id]) data[column.id] = <CreateEditField>{}
                        section.formData[column.id] = data[column.id].value
                        continue
                    }

                    var unit = ''
                    if (column.unitName && column.unitName.replace(/^\s+|\s+$/g, '').length > 0) unit = ' [' + column.unitName + ']'
                    var visible = true
                    if (column.id == CommonHelper.locationLatitude || column.id == CommonHelper.locationLongitude) {
                        visible = false
                        if (!locationSelectedButtonAdded) {
                            items.push({
                                cssClass: 'data_type_id_' + column.id,
                                dataField: column.id.toString(),
                                visible: true,
                                label: {
                                    text: i18n('Common', 'SelectFromMap')
                                },
                                colSpan: 2,
                                template: '<location-select coords="::getCoords()" callback="::onLocationSelected"></location-select>',
                                validationRules: []
                            })
                            locationSelectedButtonAdded = true
                            fieldIsAdded = true
                        }
                    }

                    if (hasViewDictionary.tryGetValue(column.referenceTypeId) === true) {
                        visible = false
                        var actionValue = 'empty'
                        if (data) {
                            if (data[column.id])
                                actionValue = data[column.id].value
                        }

                        if (actionValue == 'empty' && (column.id == Enums.DataType.HELPER_ID_OPERATOR_REGISTERING || column.id == Enums.DataType.HELPER_ID_OPERATOR_CREATOR) && section.type != 'formGrid') {
                            actionValue = this.api.login.getUser().id.toString()
                        }

                        items.push({
                            cssClass: 'data_type_id_' + column.id,
                            dataField: column.id.toString(),
                            visible: true,
                            label: {
                                text: column.caption.split(" ").map((word: string) => word.substring(0, maxCharCount)).join(" ") + unit
                            },
                            colSpan: 1,
                            template: this.getSelectPopoverTemplate(actionValue, column, section),
                            validationRules: [],
                            isSelectPopover: true
                        })
                        fieldIsAdded = true
                    }

                    if (column.referenceTypeId === Enums.ReferenceType.Color) {
                        items.push({
                            cssClass: 'data_type_id_' + column.id,
                            dataField: column.id.toString(),
                            visible: visible,
                            label: {
                                text: column.caption.split(" ").map(word => word.substring(0, maxCharCount)).join(" ") + unit
                            },
                            editorType: 'dxColorBox',
                            editorOptions: {
                                applyValueMode: 'instantly' // bo w ten wersji DX ta kontrolka się gliczuje.
                            },
                            validationRules: [{
                                type: 'pattern',
                                pattern: ''
                            }]
                        } as any)

                        fieldIsAdded = true
                    }

                    if (!fieldIsAdded) {
                        items.push({
                            cssClass: 'data_type_id_' + column.id,
                            dataField: column.id.toString(),
                            visible: visible,
                            label: {
                                text: column.caption.split(" ").map(word => word.substring(0, maxCharCount)).join(" ") + unit
                            },
                            validationRules: [{
                                type: 'pattern',
                                pattern: ''
                            }]
                        })
                        fieldIsAdded = true
                    }

                    if (fieldIsAdded) {
                        if (section.required && column.type != CommonHelper.boolean && section.type != 'formGrid') {
                            for (var j = 0; j < section.required.length; j++) {
                                var req = section.required[j]
                                if (req.id == column.id) {
                                    items[items.length - 1].validationRules.push({
                                        type: 'required',
                                        message: i18n('Common', 'RequiredField')
                                    })
                                    break
                                }
                            }
                        }

                        if (column.referenceTypeId !== Enums.ReferenceType.Color) {
                            let promise = this.addValidationRules(section, column, idReferenceType, items[items.length - 1])

                            if (promise) {
                                promises.push(promise)
                            }
                        }

                        section.formData[column.id] = this.getFieldValue(data, column)
                    }
                }

                const endUpdate = () => {
                    this.$timeout(() => {
                        //section.form.repaint() //it reinits select-popover and if select-popover with value it invokes new request
                        section.form.endUpdate()
                        this.$scope.isLoading = false
                    })
                }

                if (promises && promises.length && promises.length > 0) {
                    this.$q.all(promises)
                        .catch(e => {
                            console.error(e)
                        }).finally(() => {
                            endUpdate()
                        })
                } else {
                    endUpdate()
                }
            });
    }

    isSectionsValid(sections: CreateEditSection[]) {
        var isValid = true

        sections.forEach((section, index) => {
            this.$scope['showSectionError' + index] = false

            if (section.form && !(<any>section.form.validate()).isValid) {
                section.showRequiredError = true
                this.$scope['showSectionError' + index] = true
                isValid = false
            }

            // only for forms, not grids
            if (section.type == 'form' && section.items) {
                section.items.forEach(item => {
                    if (item.isSelectPopover == true) {
                        item.validationRules.forEach(rule => {
                            if (rule.type == "required") {
                                if (section.formData[item.dataField] == null || section.formData[item.dataField] == '') {
                                    section.showRequiredError = true
                                    this.$scope['showSectionError' + index] = true
                                    isValid = false

                                    $("[datatype-id=" + item.dataField + "] .select-container").addClass('dx-invalid dx-texteditor')
                                    $("[datatype-id=" + item.dataField + "] .select-button").addClass('dx-invalid dx-texteditor')
                                }
                            }
                        })
                    }

                    if (item.dataField === CommonHelper.locationLatitude.toString() || item.dataField === CommonHelper.locationLongitude.toString()) {
                        if (item.validationRules.map(rule => rule.type).indexOf('required') >= 0) {
                            if (!section.formData[item.dataField] || section.formData[item.dataField] === '') {
                                section.showRequiredError = true
                                this.$scope['showSectionError' + index] = true
                                isValid = false

                                $(".location-select").addClass('dx-invalid dx-texteditor')
                                $(".location-select .select-button").addClass('dx-invalid dx-texteditor')
                            }
                        }
                    }

                    // Validate select with note controls
                    this.CHANGE_STATUS_ID_DATA_TYPES.forEach((dataTypes: [Enums.DataType, Enums.DataType]) => {
                        if (item.dataField === dataTypes[0].toString()
                            && item.validationRules.map(rule => rule.type).indexOf('required') >= 0
                            && (section.formData[item.dataField] == null || section.formData[item.dataField] == '')) {
                            section.showRequiredError = true
                            this.$scope['showSectionError' + index] = true
                            isValid = false

                            $("[table-id=" + item.dataField + "] .dx-dropdownbox").addClass('dx-invalid')
                        }
                    })
                })
            }

            return true
        })

        return isValid
    }

    isIdColumn(column: CreateEditFieldSettings, formType) {
        // TODO: zamienić na referenceType i primaryKeyColumn z ActiveView!
        switch (formType) {
            case PopupType.LOCATION_POPUP:
                if (column.id === Enums.DataType.HELPER_ID_LOCATION) {
                    return true
                }
                break
            case PopupType.DEVICE_POPUP:
                if (column.id === Enums.DataType.HELPER_SERIAL_NBR) {
                    return true
                }
                break
            case PopupType.METER_POPUP:
                if (column.id === Enums.DataType.HELPER_ID_METER) {
                    return true
                }
                break
            case PopupType.USER_POPUP:
                if ([CommonHelper.userColumnId, CommonHelper.actorColumnId].indexOf(column.id) > -1) {
                    return true
                }
                break
            case PopupType.ISSUE_POPUP:
                if (column.id === Enums.DataType.HELPER_ID_ISSUE) {
                    return true
                }
                break
            case PopupType.TASK_POPUP:
                if (column.id === Enums.DataType.HELPER_ID_TASK) {
                    return true
                }
                break
            case PopupType.DISTRIBUTOR_POPUP:
                if (column.id === Enums.DataType.HELPER_ID_DISTRIBUTOR) {
                    return true
                }
                break
            case PopupType.DISTRIBUTOR_POPUP:
                if (column.id === Enums.DataType.HELPER_ID_ALARM) {
                    return true
                }
                break
            case PopupType.ROUTE_POPUP:
                if (column.id === Enums.DataType.HELPER_ID_ROUTE) {
                    return true
                }
                break
        }
        return false
    }

    protected getReferenceTable(referenceType, idDataType): JQueryPromise<any> {
        if (this.referenceTypeService != null) {
            return this.referenceTypeService
                .getReferenceObjects(referenceType)
                .then((result: DataProviderListResult<IReferenceType>) => {
                    const referenceTableUniqueId = idDataType + '_' + referenceType
                    const referenceTableName = 'referenceTable' + referenceTableUniqueId

                    this.$scope[referenceTableName] = _.map(result.objects, referenceObject => {
                        return {
                            id: referenceObject.getReferenceKey(),
                            caption: referenceObject.toString()
                        }
                    });

                    return {
                        rows: <ColumnModel[]>this.$scope[referenceTableName],
                        referenceTableName
                    }
                });
        }

        const deferred = $.Deferred<any>();

        this.localDictionary
            .getReferenceTable(referenceType, idDataType, 1, 100)
            .then(table => {
                if (table && table.selectBoxData) {
                    var referenceTableUniqueId = idDataType + '_' + referenceType
                    var oldReferences = this.referenceDict.filter(r => r.idDataType == idDataType && r.referenceType == referenceType)
                    if (oldReferences.length > 0) {
                        referenceTableUniqueId = oldReferences[0].referenceTableUniqueId
                    } else {
                        this.referenceTableCount += 1
                        //count = this.referenceTableCount
                        this.referenceDict.push({
                            idDataType: idDataType,
                            referenceType: referenceType,
                            referenceTableUniqueId
                        })
                    }

                    var referenceTableName = 'referenceTable' + referenceTableUniqueId
                    this.$scope[referenceTableName] = table.selectBoxData

                    deferred.resolve({
                        rows: <ColumnModel[]>this.$scope[referenceTableName],
                        referenceTableName
                    })
                }


                deferred.resolve(null);
            })
            .catch((e: any) => {
                deferred.catch(e);
            });


        return deferred.promise();
    }

    addValidationRules(section: CreateEditSection, column: CreateEditFieldSettings, idReferenceType: number, item = null) {
        let defer = this.$q.defer()
        let requestSent = false
        item.editorOptions = {}

        if (!item.validationRules)
            item.validationRules = []

        if ((!column.isEditable || (column.referenceTypeId && column.referenceTypeId === idReferenceType)) && this.$scope.isEditMode)
            item.editorOptions.readOnly = true

        switch (column.type) {
            case CommonHelper.integer:
                var referenceType = column.referenceTypeId
                if (!referenceType) {
                    if (item) {
                        if (section.type != 'formGrid') {
                            item.validationRules.push({
                                type: 'pattern',
                                pattern: '^-?[0-9]{0,}$',
                                message: i18n('Common', 'IntegerField')
                            })
                        }

                        if (column.format != null) {
                            if (column.format.numberMaxValue) {
                                item.validationRules.push({
                                    type: 'range',
                                    max: column.format.numberMaxValue,
                                    message: i18n('Common', 'NumberMaxValue') + ' ' + column.format.numberMaxValue
                                })
                            }
                            if (column.format.numberMinValue) {
                                item.validationRules.push({
                                    type: 'range',
                                    min: column.format.numberMinValue,
                                    message: i18n('Common', 'NumberMinValue') + ' ' + column.format.numberMinValue
                                })
                            }
                        }

                        item.editorOptions.onValueChanged = (e) => {
                            if ((e.value == '' && e.previousValue) || e.value)
                                this.editedItems[column.id] = true
                        }
                    }
                    break
                }
                else if (referenceType && !item.template) {
                    let isSelectNote: boolean = false;

                    this.CHANGE_STATUS_ID_DATA_TYPES.forEach((dataTypes: [Enums.DataType, Enums.DataType]) => {
                        const [selectIdDataType, noteIdDataType]: [Enums.DataType, Enums.DataType] = dataTypes

                        if (column.id === selectIdDataType) {
                            const noteDataType: OpDataType = this.userSession.getDataProvider().DataType.getDataTypeLocal(noteIdDataType)

                            if (noteDataType != null) {
                                isSelectNote = true
                                requestSent = true

                                this.getChangeStatusTemplate(referenceType, column, noteDataType)
                                    .then((template: string) => {
                                        if (template) {
                                            item.template = template
                                        }
                                        defer.resolve(template)
                                    })
                            }
                        }
                    })

                    if (!isSelectNote) {
                        requestSent = true
                        this.getSelectBoxTemplate(referenceType, column, item.editorOptions.readOnly, section).then(template => {
                            if (template) {
                                item.template = template
                            }
                            defer.resolve(template)
                        })
                    }
                }
                break
            case CommonHelper.string:
                section.formData[column.id] = ""
                if (column.id == CommonHelper.userColumnPassword) {
                    // Field is set to readOnly to prevent browser to auto filling fields with stored password
                    item.editorOptions.mode = 'password'
                    item.editorOptions.readOnly = true
                    item.editorOptions.onFocusIn = (e: any) => {
                        e.component.option('readOnly', false)
                    }
                }
                if (item) {
                    if (section.type != 'formGrid') {
                        if (column.format != null && column.format.textMinLength) {
                            item.validationRules.push({
                                type: 'stringLength',
                                min: column.format.textMinLength,
                                message: i18n('Common', 'MinNumberOfCharacters') + ' ' + column.format.textMinLength
                            })
                        }
                    }
                    if (column.format != null && column.format.textMaxLength) {
                        item.validationRules.push({
                            type: 'stringLength',
                            max: column.format.textMaxLength,
                            message: i18n('Common', 'MaxNumberOfCharacters') + ' ' + column.format.textMaxLength
                        })
                    }
                    if (section.type == 'formGrid') {
                        item.editorOptions.showClearButton = !_.some(section.required, (requiredField: CreateEditFieldSettings) => requiredField.id == column.id)
                    }
                    item.editorOptions.onValueChanged = (e) => {
                        if ((e.value == '' && e.previousValue) || e.value)
                            this.editedItems[column.id] = true
                    }
                }
                break
            case CommonHelper.datetime:
                section.formData[column.id] = null//new Date()//Nie mozna przypisywać daty obecnej w puste miejsca, ponieważ doprowadzi to do wielkiego zamieszania jeśli ktoś nieświadomie będzie zatwierdzać takie zmiany

                let placeholder: string = TypeHelper.emptyString
                let showClearButton: boolean = false
                if (this.$scope.bulkGridData != null) {
                    const comparationResult: { comparation: BulkEditComparationMode, selectedValue: string, selectedId: number } = this.getBulkGridColumnDataComparation(column.id, section)
                    placeholder = comparationResult.selectedValue
                    showClearButton = !_.some(section.required, (requiredField: CreateEditFieldSettings) => requiredField.id == column.id)
                }

                item.template = '<div table-id="' + column.id + '" dx-date-box="{onInitialized: onDateBoxInitialized, placeholder: \'' + placeholder + '\', showClearButton: ' + showClearButton + ', acceptCustomValue: ' + showClearButton + ', displayFormat: dateFormat, bindingOptions: { value: \'panel.formData[' + column.id + ']\' }, onValueChanged: panel.onDateFieldChanged }" style="width: 100%;"></div>'
                break
            case CommonHelper.real:
                if (item) {
                    item.validationRules.push({
                        type: 'numeric',
                        message: i18n('Common', 'NumericField')
                    })
                    if (column.format != null) {
                        if (column.format.numberMaxValue) {
                            item.validationRules.push({
                                type: 'range',
                                max: column.format.numberMaxValue,
                                message: i18n('Common', 'NumberMaxValue') + ' ' + column.format.numberMaxValue
                            })
                        }
                        if (column.format.numberMinValue) {
                            if (section.type != 'formGrid') {
                                item.validationRules.push({
                                    type: 'range',
                                    min: column.format.numberMinValue,
                                    message: i18n('Common', 'NumberMinValue') + ' ' + column.format.numberMinValue
                                })
                            }
                        }
                        if (column.format.numberMinPrecision && column.format.numberMaxPrecision) {
                            item.validationRules.push({
                                type: 'pattern',
                                pattern: '^\\d+\\.\\d{' + column.format.numberMinPrecision + ',' + column.format.numberMaxPrecision + '}$',
                                message: i18n('Common', 'NumberPrecisionRange') + ' ' + column.format.numberMinPrecision + '-' + column.format.numberMaxPrecision
                            })
                        }
                        else if (column.format.numberMaxPrecision) {
                            item.validationRules.push({
                                type: 'pattern',
                                pattern: '^\\d+(\\.\\d{1,' + column.format.numberMaxPrecision + '})?$',
                                message: i18n('Common', 'NumberMaxPrecision') + ' ' + column.format.numberMaxPrecision
                            })
                        }
                        else if (column.format.numberMinPrecision) {
                            item.validationRules.push({
                                type: 'pattern',
                                pattern: '^\\d+\\.\\d{' + column.format.numberMinPrecision + ',}$',
                                message: i18n('Common', 'NumberMinPrecision') + ' ' + column.format.numberMinPrecision
                            })
                        }
                    }

                    if (section.type == 'formGrid') {
                        item.editorOptions.showClearButton = !_.some(section.required, (requiredField: CreateEditFieldSettings) => requiredField.id == column.id)
                    }
                }
                break
            case CommonHelper.boolean:
                section.formData[column.id] = false
                if (item) {
                    item.editorType = "dxCheckBox"
                    item.editorOptions.onValueChanged = (e) => {
                        this.editedItems[column.id] = true
                    }
                    item.validationRules[0] = {
                        type: 'pattern',
                        pattern: ''
                    }
                }
                break
            default:
                break
        }

        if (!requestSent)
            defer.resolve({})

        return defer.promise
    }

    getFieldValue(data, column: CreateEditFieldSettings) {
        var field = data ? data[column.id] : null

        if (field) {
            return this.prepareValue(field.value, column.id, column.type)
        }
        else if (column['defaultValue']) {
            return this.prepareValue(column['defaultValue'], column.id, column.type)
        } else if (this.$scope.customDataSourcesDefaultValues != null && this.$scope.customDataSourcesDefaultValues[column.id] != undefined) {
            return this.prepareValue(this.$scope.customDataSourcesDefaultValues[column.id], column.id, column.type)
        } else {
            if (column.type == CommonHelper.datetime) {
                return null
            }
            else if (column.type == CommonHelper.boolean) {
                return false
            }
            if (column.id == CommonHelper.priorityColumnId) {
                return 1
            }
            if (column.id == CommonHelper.taskStatusColumnId) {
                return 1
            }
            if (column.id == CommonHelper.issueStatusColumnId) {
                return 1
            }
            if (column.id == CommonHelper.registerOperatorColumnId) {
                return this.api.login.getUser().id
            }
            if (column.id == Enums.DataType.HELPER_ID_OPERATOR_CREATOR) {
                return this.api.login.getUser().id
            }
            if (column.id == Enums.DataType.HELPER_ID_PACKAGE_STATUS) {
                return Enums.PackageStatus.New
            }
            return ""
        }
    }

    private prepareValue(value: any, idDataType: number, idDataTypeClass: number): any {
        if (idDataTypeClass == CommonHelper.datetime) {
            if (value != null) {
                return ConvertHelper.stringToDate(value)
            }
            else {
                return null//new Date()//Nie mozna przypisywać daty obecnej w puste miejsca, ponieważ doprowadzi to do wielkiego zamieszania jeśli ktoś nieświadomie będzie zatwierdzać takie zmiany
            }
        } else if (idDataTypeClass == CommonHelper.boolean) {
            return !!value
        } else {
            if (idDataType == CommonHelper.priorityColumnId) {
                if (value == null) {
                    return 1
                }
            }

            return value
        }
    }

    private getChangeStatusTemplate(referenceTypeId: Enums.ReferenceType, column: CreateEditFieldSettings, noteDataType: OpDataType) {
        const selectDataTypeId: Enums.DataType = column.id

        return this.getReferenceTable(referenceTypeId, selectDataTypeId)
            .then((table: any) => {
                if (table) {
                    return `
    <div id="table${selectDataTypeId}" table-id="${selectDataTypeId}">
    <select-with-note options="{
    selectDataType: ${selectDataTypeId},
    selectDataSource: ${table.referenceTableName},
    selectLabel: '${column.caption}',
    selectValueFieldName: 'id',
    selectValue: panel.formData[${selectDataTypeId}],

    noteDataType: ${noteDataType.idDataType},
    noteLabel: '${noteDataType.toString()}',
    noteValue: panel.formData[${noteDataType.idDataType}],
    
    onSelectValueChanged: panel.onSelectNoteValueChanged,
    onNoteValueChanged: panel.onNoteValueChanged
    }"></select-with-note>
    </div>`

                }

                return null
            })
    }



    // Reference Lists

    private getIssueStatuses(currentIssueStatus: Enums.IssueStatus): JQueryPromise<OpIssueStatus[]> {
        if (currentIssueStatus == null) {
            return $.Deferred().resolve(null).promise()
        }

        return this.userSession
            .getDataProvider().Issue
            .getNextIssueStatuses(currentIssueStatus)
    }

    private getTaskStatuses(currentTaskStatus: Enums.TaskStatus): JQueryPromise<OpTaskStatus[]> {
        const idTaskStatusesDeferred: JQueryDeferred<Enums.TaskStatus[]> = $.Deferred<Enums.TaskStatus[]>()

        if (currentTaskStatus != null && currentTaskStatus !== -1) {
            idTaskStatusesDeferred.resolve([currentTaskStatus])
        }
        else {
            const columnValues: any[] = this.getBulkEditColumnValues(Enums.DataType.HELPER_ID_TASK_STATUS)

            if (columnValues != null) {
                this.getCorrespondingReferenceTypes(Enums.ReferenceType.IdTaskStatus, columnValues)
                    .then((valueReferenceDict: Dictionary<IReferenceType>) => {
                        if (valueReferenceDict != null) {
                            const idTaskStatuses: Enums.TaskStatus[] = valueReferenceDict
                                .values()
                                .map((referenceType: IReferenceType) => referenceType.getReferenceKey())

                            return idTaskStatusesDeferred.resolve(idTaskStatuses)
                        }

                        return idTaskStatusesDeferred.resolve(null)
                    })
            }
            else {
                idTaskStatusesDeferred.resolve(null)
            }
        }

        return idTaskStatusesDeferred.then<OpTaskStatus[]>((idTaskStatuses: Enums.TaskStatus[]) => {
            if (_.isArray(idTaskStatuses) && idTaskStatuses.length > 0) {
                return this.userSession
                    .getDataProvider().Task
                    .getNextTaskStatuses(idTaskStatuses)
            }

            return null
        })
    }

    private getPackageStatuses(currentPakageStatus: Enums.PackageStatus): JQueryPromise<OpPackageStatus[]> {
        if (this.$scope.customDataSources) {
            return $.Deferred().resolve(this.$scope.customDataSources.tryGetValue(Enums.DataType.HELPER_ID_PACKAGE_STATUS)).promise()
        }

        return this.userSession
            .getDataProvider().Package
            .getNextCombinedPackageStatuses(currentPakageStatus)
    }

    // Reference Lists End


    // Jałowizna

    /**
     * Extracts values from the bulk grid for the given datatype.
     */
    private getBulkEditColumnValues(idDataType: Enums.DataType, section: CreateEditSection = null): any[] {
        if (section == null && _.size(this.$scope.panels > 1)) {
            section = this.$scope.panels[0]
        }

        if (
            idDataType != null && section != null && _.isArray(section.columns) && _.isArray(this.$scope.bulkGridColumns) && _.isArray(this.$scope.bulkGridData)
        ) {
            const currentColumnModel: ColumnModel = _.find(section.columns, (column: any) => column.id === idDataType)

            if (currentColumnModel != null) {
                const currentGridColumn = _.find(this.$scope.bulkGridColumns, (gridColumn: any) => gridColumn.caption === currentColumnModel.caption)

                if (currentGridColumn != null) {
                    return this.$scope.bulkGridData.map((gridData: any) => gridData[currentGridColumn.dataField])
                }
            }
        }

        return null
    }

    /**
     * Returns a dictionary where keys are the given values and values are the corresponding referenece types.
     * It uses reference type's toString method to compare objects.
     */
    private getCorrespondingReferenceTypes<TRefereneceType extends IReferenceType>(referenceType: Enums.ReferenceType, values: any[]): JQueryPromise<Dictionary<IReferenceType>> {
        if (referenceType == null || !_.isArray(values)) {
            return $.Deferred().resolve(null).promise()
        }

        return this.userSession
            .getDataProvider().System
            .getDictionaries([referenceType])
            .then((dicts: Dictionary<Dictionary<IReferenceType>>) => {
                if (dicts != null) {
                    const referenceTypeDict: Dictionary<IReferenceType> = dicts.tryGetValue(referenceType)

                    if (referenceTypeDict != null) {
                        const valueReferenceDict = new Dictionary<IReferenceType>(null)
                        const distinctValues: any[] = _.unique(values)

                        distinctValues.forEach((value: any) => {
                            referenceTypeDict
                                .values()
                                .forEach((referenceType: IReferenceType) => {
                                    if (value.toString().toLowerCase() === referenceType.toString().toLowerCase()) {
                                        valueReferenceDict.add(value, referenceType)
                                    }
                                })
                        })

                        return valueReferenceDict
                    }
                }

                return null
            })
            .fail((error: any) => {
                return null
            })
    }

    // Jałowizna End


    //#region Reference Types with Views

    private getSelectPopoverTemplate(actionValue: string, column: CreateEditFieldSettings, section: CreateEditSection): string {
        if (column != null && column.id) {
            let showClearButton: boolean = !_.some(section.required, (requiredField: CreateEditFieldSettings) => requiredField.id == column.id)
            let selectedValue: string = TypeHelper.emptyString

            if (this.$scope.bulkGridData != null) {
                const comparationResult: BulkEditComparation = this.getBulkGridColumnDataComparation(column.id, section)

                if (showClearButton) { //field isnt required. check for multiple selection
                    showClearButton = this.isSelectPopoverClearButtonVisible(comparationResult.comparation)
                }
                selectedValue = comparationResult.selectedValue
                actionValue = comparationResult.selectedId != null ? comparationResult.selectedId.toString() : null
            }

            return '<select-popover selected-id="' + actionValue + '" datatype-id="' + column.id + '" options="{ referenceTypeId: ' + column.referenceTypeId + ', showClearButton: ' + showClearButton + '}" selected-value="\'' + selectedValue + '\'" callback="::onPopoverValueIdSelected"></select-popover>'
        }
    }

    //#endregion

    //#region Reference Types with out Views

    protected getSelectBoxOptions(referenceType: number, idDataType: number) {
        return this
            .getReferenceTable(referenceType, idDataType)
            .then(table => {
                const options: DevExpress.ui.dxSelectBoxOptions = {
                    dataSource: new DataSource({
                        store: table.rows,
                        paginate: true
                    }),
                    value: null,
                    valueExpr: 'id',
                    searchEnabled: true,
                    displayExpr: 'caption'
                }

                return {
                    options,
                    data: table.rows
                }
            })
    }

    private getSelectBoxTemplate(referenceType: Enums.ReferenceType, column: CreateEditFieldSettings, readOnly: boolean = false, section: CreateEditSection) {
        const idDataType: Enums.DataType = column.id

        return this
            .getReferenceTable(referenceType, idDataType)
            .then((table: any) => {
                if (table != null) {
                    if (table.rows.length == 1 && (!this.$scope.panels[0].formData[idDataType] || this.$scope.panels[0].formData[idDataType].length == 0)) {
                        this.$scope.panels[0].formData[idDataType] = table.rows[0].id
                    }

                    table.rows.push({ id: -1, caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MultipleSelected), visible: false })

                    const customDeferred: ng.IDeferred<string> = this.$q.defer<string>()

                    if (_.contains([Enums.DataType.HELPER_ID_ISSUE_STATUS, Enums.DataType.HELPER_ID_TASK_STATUS, Enums.DataType.HELPER_ID_PACKAGE_STATUS, Enums.DataType.HELPER_ID_LOCATION_TYPE],
                        idDataType)) {
                        this.getCustomSelectBoxRows(table, idDataType)
                            .then((rows: any[]) => {
                                if (rows != null) {
                                    rows.push({ id: -1, caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MultipleSelected), visible: false })

                                    this.$scope[table.referenceTableName] = rows
                                }

                                customDeferred.resolve()
                            })
                    }
                    else {
                        customDeferred.resolve()
                    }

                    return customDeferred.promise.then(() => {
                        return this.getDefaultSelectBoxTemplate(idDataType, table.referenceTableName, readOnly, section)
                    })
                }

                return null
            })
    }

    private getCustomSelectBoxRows(table: any, idDataType: Enums.DataType): JQueryPromise<any[]> {
        switch (idDataType) {
            case Enums.DataType.HELPER_ID_ISSUE_STATUS:
                return this
                    .getIssueStatuses(this.$scope.panels[0].formData[Enums.DataType.HELPER_ID_ISSUE_STATUS])
                    .then((issueStatuses: OpIssueStatus[]) => {
                        if (this.$scope.panels[0].formData[Enums.DataType.HELPER_ID_ISSUE_STATUS] === -1) { //-1 is multiple selected
                            ToastHelper.showWarning(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DifferentStatusesEditWarning))
                            return []
                        }

                        if (_.isArray(issueStatuses)) {
                            const idIssueStatuses: Enums.IssueStatus[] = issueStatuses.map((issueStatus: OpIssueStatus) => issueStatus.idIssueStatus)

                            return table.rows.filter(sbd => idIssueStatuses.indexOf(sbd.id) >= 0)
                        }

                        console.warn(CommonCreateEdit.LOG_STRING, `Unable to load flow statuses for datatype: HELPER_ID_ISSUE_STATUS. Returning all statuses.`)

                        return table.rows
                    })

            case Enums.DataType.HELPER_ID_TASK_STATUS:
                return this
                    .getTaskStatuses(this.$scope.panels[0].formData[Enums.DataType.HELPER_ID_TASK_STATUS])
                    .then((taskStatuses: OpTaskStatus[]) => {
                        if (_.isArray(taskStatuses)) {
                            const idTaskStatuses: Enums.IssueStatus[] = taskStatuses.map((taskStatus: OpTaskStatus) => taskStatus.idTaskStatus)

                            return table.rows.filter(sbd => idTaskStatuses.indexOf(sbd.id) >= 0)
                        }

                        console.warn(CommonCreateEdit.LOG_STRING, `Unable to load flow statuses for datatype: HELPER_ID_TASK_STATUS. Returning an empty list.`)

                        return []
                    })

            case Enums.DataType.HELPER_ID_PACKAGE_STATUS:
                return this
                    .getPackageStatuses(this.$scope.panels[0].formData[Enums.DataType.HELPER_ID_PACKAGE_STATUS])
                    .then((packageStatuses: OpPackageStatus[]) => {
                        if (_.isArray(packageStatuses)) {
                            const idPackageStatuses: Enums.PackageStatus[] = packageStatuses.map((packageStatus: OpPackageStatus) => packageStatus.idPackageStatus)

                            return table.rows.filter(sbd => idPackageStatuses.indexOf(sbd.id) >= 0)
                        }

                        console.warn(CommonCreateEdit.LOG_STRING, `Unable to load flow statuses for datatype: HELPER_ID_PACKAGE_STATUS. Returning an empty list.`)

                        return []
                    })

            case Enums.DataType.HELPER_ID_LOCATION_TYPE:
                if (this.$scope.customDataSources) {
                    const locationTypes: OpLocationType[] = this.$scope.customDataSources.tryGetValue(Enums.ReferenceType.IdLocationType)

                    if (_.size(locationTypes) > 0) {
                        return $.Deferred()
                            .resolve(locationTypes.map((lt: OpLocationType) => {
                                return {
                                    id: lt.idLocationType,
                                    caption: lt.toString()
                                }
                            }))
                            .promise()
                    }
                }

                return $.Deferred()
                    .resolve(table.rows)
                    .promise()

            default:
                return $.Deferred().resolve(null).promise()
        }
    }

    private getDefaultSelectBoxTemplate(idDataType: Enums.DataType, referenceTableName: string, readOnly: boolean = false, section: CreateEditSection) {
        let showClearButton: boolean = false

        if (this.$scope.bulkGridData != null) {
            showClearButton = !_.some(section.required, (requiredField: CreateEditFieldSettings) => requiredField.id == idDataType)
        }

        this.$scope[referenceTableName] = new DataSource({
            store: this.$scope[referenceTableName],
            paginate: true,
            pageSize: 100
        });

        return '<div id="table' + idDataType + '" table-id="' + idDataType + '" dx-select-box="{dataSource: ' + referenceTableName + ', onSelectionChanged: panel.onFieldChanged, onValueChanged: panel.onFieldValueChanged, onInitialized: panel.initializedHandler, value: panel.formData[' + idDataType + '], valueExpr: \'id\', searchEnabled: true, showClearButton: ' + showClearButton + ', buttons: panel.inputButtons[' + idDataType + '], displayExpr: \'caption\', readOnly: ' + readOnly + ' }"></div>'
    }

    //#endregion

    //#region Utils

    private getHasViewDictionary(settings: ReadonlyArray<CreateEditFieldSettings>): JQueryPromise<Dictionary<boolean>> {
        if (this.referenceTypeService != null) {
            return this.referenceTypeService.isViewReferenceTypes(_.map(settings, setting => setting.referenceTypeId))
        }

        const resultDict: Dictionary<boolean> = new Dictionary<boolean>(null, KeyType.Number);

        _.forEach(settings, setting => {
            if (setting.referenceTypeId != null) {
                resultDict.add(setting.referenceTypeId, CommonHelper.getReferenceSettings(this.userSession.getDataProvider(), setting.referenceTypeId, setting.id, this.localDictionary, null).isSelectGrid)
            }
        });

        return $.Deferred<Dictionary<boolean>>().resolve(resultDict).promise();
    }

    //#endregion

    protected getBulkGridColumnDataComparation(idDataType: number, section: CreateEditSection): BulkEditComparation {
        const values: any[] = this.getBulkEditColumnValues(idDataType, section)
        const filteredData: any[] = _.filter(values, (data: any) => data == values[0])

        if (_.size(filteredData) !== _.size(values)) {
            return { comparation: BulkEditComparationMode.Multiple, selectedValue: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MultipleSelected), selectedId: -1 }
        } else {
            if (_.size(values) > 0 && values[0] != null) {
                return { comparation: BulkEditComparationMode.Single, selectedValue: filteredData[0], selectedId: -1 }
            }
            return { comparation: BulkEditComparationMode.Empty, selectedValue: TypeHelper.emptyString, selectedId: null }
        }
    }

    private isSelectPopoverClearButtonVisible(comparation: BulkEditComparationMode): boolean {
        if (comparation === BulkEditComparationMode.Single) {
            return true
        } else if (comparation === BulkEditComparationMode.Multiple) {
            return true
        } else if (comparation === BulkEditComparationMode.Empty) {
            return false
        }

        return false
    }
}
